import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  bottom: 20px;\n  left: 20px;\n  position: fixed;\n  right: 20px;\n  top: auto;\n  width: auto;\n  max-height: 60vh;\n  padding: 0px;\n  list-style: none;\n  border-radius: ", ";\n  margin: 10px 0px 0px;\n  overflow: auto;\n  background-color: rgb(255, 255, 255);\n  box-shadow: ", ";\n  z-index: 2;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  bottom: 0;\n  left: 0;\n  opacity: 0.6;\n  position: fixed;\n  right: 0;\n  top: 70px;\n  z-index: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../utils/styling/styled-components';
var Overlay = styled.div(_templateObject(), function (props) {
  return props.theme.colors.slate;
});
var Container = styled.ul(_templateObject2(), function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.shadows.lgMedium;
});

var ResponsiveMenu = function ResponsiveMenu(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Overlay, {
    onClick: onClick
  }), /*#__PURE__*/React.createElement(Container, {
    className: className
  }, children));
};

export { ResponsiveMenu };